import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from '../services/auth.service';

@Injectable()
export class LoginGuard implements CanActivate {
 
    constructor(
        private router: Router,
        private authService: AuthService
    ) {
    }
 
    canActivate(): Observable<boolean> {
        return this.authService.isAuthenticated$
            .do(isLogged => {
                return isLogged && this.router.navigate(['/'])
            })
            .mapTo(true);
    }
}


// WEBPACK FOOTER //
// ./src/app/core/guards/login.guard.ts